import api from './api';
import { Employee, CreateEmployeeDto, UpdateEmployeeDto } from '../types/employee.types';

export const employeeService = {
  async getAllEmployees(): Promise<Employee[]> {
    const response = await api.get<Employee[]>('/employees');
    return response.data;
  },

  async createEmployee(data: CreateEmployeeDto): Promise<Employee> {
    const response = await api.post<Employee>('/employees', data);
    return response.data;
  },

  async updateEmployeeStatus(id: number, data: UpdateEmployeeDto): Promise<Employee> {
    const response = await api.patch<Employee>(`/employees/${id}`, data);
    return response.data;
  },
};
